module.exports = __webpack_public_path__ + "img/box5-img-1.146d36de.png";